var mod = function(){
	if (Modernizr.mq('(min-width: 968px)')) {
		$('.sub-menu').removeClass('open');
		$('.primary-navigation-mobile').removeClass('open-mobile');
		//display sub-menu on hover in desktop view
	}
};

$(function() {
	$(window).resize(mod);
	mod();

	//Load images lazily 
	$('.img').Lazy({
		visibleOnly: true
	});
});

jQuery(document).ready(function($) {

    if( $('.banner-container h1').html() === "" ){
    	var title_opts = ["Lives", "Works", "Learns", "Plays", "Creates", "Unwinds"];
    	var rand_title = title_opts[Math.floor(Math.random() * title_opts.length)];
        $('.banner-container h1').hide().html("The World<br/>"+rand_title+" Here").fadeIn(1000);
	}

	getCategory();

	//make nav sticky after scrolling down 96 pixels
	$(window).scroll(function() {    
		var scroll = $(window).scrollTop();
		if(scroll < 48){
			$(".main-header").removeClass("compact");
		}else if(scroll > 96){
			$(".main-header").addClass("compact");
		}
	});

	$(".variable-sizes").each(function(){
	
		//Traverse the DOM finding variable size card blocks with less than 3 elemetns and add classes to handle tablet view.
		var cardCount = $(this).find('.card').length;
		if(cardCount == 3){
			$(this).find('.card').first().addClass("tablet-large");
		}
		else if(cardCount == 2){
			$(this).find('.card').addClass("tablet-medium");
		}
		
		//Mark first card as featured for Mobile
		//$(this).find('.card').first().addClass("featured");
	});

	//JQUERY DOT DOT DOT
	$(".summary").dotdotdot({
		watch: true
	});

	$(".card header").dotdotdot({
		watch: true
	});
	


	// var $dotdotdotSummary = $( '.event-description' );
	// $dotdotdotSummary.dotdotdot({
	// 	// Prevents the <a class="toggle" /> from being removed
	// 	keep: '.read-more'
	// });
	// // Get the dotdotdot API
	// var api = $dotdotdotSummary.data( 'dotdotdot' );	
	// $dotdotdotSummary.on(
	// 	'click',
	// 	'.read-more',
	// 	function( e )
	// 	{
	// 		e.preventDefault();
	// 		var eventDetailsOffset = $("#event").offset().top - 70;
	// 		//	When truncated, restore
	// 		if ( $dotdotdotSummary.hasClass( 'ddd-truncated' ) )
	// 		{
	// 			api.restore();
	// 			$dotdotdotSummary.addClass( 'open' );
	// 			$dotdotdotSummary.find('.read-more a').html('Show Less<i class="icon arrow-icon"></i>');
	// 			$("html, body").animate({scrollTop : eventDetailsOffset}, 'fast');
	// 		}

	// 		//	Not truncated, truncate
	// 		else
	// 		{
	// 			$dotdotdotSummary.removeClass( 'open' );
	// 			$dotdotdotSummary.find('.read-more a').html('Show More<i class="icon arrow-icon"></i>');
	// 			api.truncate();
	// 			api.watch();
	// 		}
	// 	}
	// );

	$('.more-link').on('click', function(e){
		e.preventDefault();
		var wrappingParent = $(this).closest('.shortened');
		wrappingParent.hide();
		wrappingParent.next().show();

	});

	//Inject icons into menu items on mobile
	$('.footer-nav>ul>li>a').each(function(){
		if($(this).html()!="What’s On"){  //exclude whats on
			$(this).after('<i class="icon down-icon-grey expand"></i>');
		}
	});
  
	// $('.footer-nav>ul>li>a').append('<i class="icon down-icon-grey "></i>');
	$('.primary-navigation-mobile>ul>li>a').each(function(){
		if($(this).html()!="What’s On"){  //exclude whats on
			$(this).after('<i class="icon down-icon-white expand"></i>');
		}
	});

	
	// hamburger nav on mobile/tablet
	$('.mobile-nav-icon').on('click',function(){
		$('.primary-navigation-mobile').slideToggle('fast');
		$('.primary-navigation-mobile').toggleClass("open-mobile");
	});

	$('.primary-navigation-mobile > .close-icon').on('click',function(){
		$('.primary-navigation-mobile').slideToggle('fast');
		$('.primary-navigation-mobile').toggleClass("open-mobile");
	});

	//inner workings of hamburger nav
	$('.primary-navigation-mobile i.expand').on('click', function(){
		$(this).next('.sub-menu').toggleClass('open');
		$(this).prev('a').toggleClass('active');
		
		if($(this).next('.sub-menu').hasClass('open')){
			$(this).removeClass('down-icon-white').addClass('up-icon-white');
		}else{
			$(this).removeClass('up-icon-white').addClass('down-icon-white');
		}
	});

	//inner workings of footer nav
	$('.footer-nav i.expand').on('click', function(e){
		$(this).next('.sub-menu').toggleClass('open');
		$(this).prev('a').toggleClass('active');
		
		if($(this).next('.sub-menu').hasClass('open')){
			$(this).removeClass('down-icon-grey').addClass('up-icon-grey');
		}else{
			$(this).removeClass('up-icon-grey').addClass('down-icon-grey');
		}
   });

	//search UI (mobile) 
	$('.search-bar > input').on('focus', function(){
		$('.search-bar').addClass('search-focus');
		$('.search-bar > ul').show();
		$('.search-overlay').show();
	});

	$('.search-bar .close-icon').on('click', function(){
		$('.search-bar').removeClass('search-focus');
		$('.search-bar > ul').hide();
		$('.search-overlay').hide();
	});

	$('.search-icon').on('click',function(){
		//console.log('click');
		$('.search-bar input').focus();
	});
	
	//Show auto-events panel if not empty
	$('.cards.auto-events').each(function(){
		if( $.trim( $(this).find('.articles').html() ) !== "" ){
			$(this).show();
		}
	});

	//tweets - make whole anchor into image
	$('.tweet-img').on('click', function(){
		var url = $(this).prev('a').attr('href');
		//console.log(url);
		window.open(url);
	});

	//banner slider
	bannerSliderInit = function(){
		$('.banner-slider').slick({
			speed: 800,
			autoplay: true,
			infinite: true,
			arrows: false,
			fade: true,
			slidesToShow: 1,
			cssEase: 'linear'
		});
	}

	//tweet slider
	$('.tweets>.wrapper>.slider>ul').on('afterChange', function(event, slick, currentSlide){
		__gaTracker('send', 'event', 'TwitterPanel', 'scroll', '');
	});
	$('.tweets>.wrapper>.slider>ul>li').on('click', function(event){
		__gaTracker('send', 'event', 'TwitterPanel', 'click', '');
	});
	$('.tweets>.wrapper>.slider>ul').slick({
		slide: 'li',
		speed: 300,
		autoplay: false,
		infinite: false,
		arrows: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		cssEase: 'linear',
		variableWidth: true,
		nextArrow: '<div class="slick-next"><span>&rsaquo;</span></div>',
		prevArrow: '<div class="slick-prev"><span>&lsaquo;</span></div>',
		swipe: true,
		// swipeToSlide: true,
		responsive: [
			{
				breakpoint: 820,
				settings: {
					slidesToShow: 4,
				}
			},{
				breakpoint: 550,
				settings: {
					slidesToShow: 3,
					centerMode: true,
					initialSlide: 1,
				}
			},{
				breakpoint: 420,
				settings: {
					slidesToShow: 2,
					centerMode: true,
					initialSlide: 1,
				}
			}
		]
	});

	//cat nav
	$('.categories>.wrapper>.slider>ul').slick({
		slide: 'li',
		speed: 200,
		autoplay: false,
		infinite: false,
		arrows: true,
		slidesToShow: 7,
		// slidesToScroll: 1,
		cssEase: 'ease-out',
		variableWidth: true,
		nextArrow: '<div class="slick-next"><span>&rsaquo;</span></div>',
		prevArrow: '<div class="slick-prev"><span>&lsaquo;</span></div>',
		swipeToSlide: true,
		responsive: [
			{
				breakpoint: 1110,
				settings: {
					slidesToShow: 7,
				}
			},{
				breakpoint: 970,
				settings: {
					slidesToShow: 6,
				}
			},{
				breakpoint: 890,
				settings: {
					slidesToShow: 5,
				}
			},{
				breakpoint: 760,
				settings: {
					slidesToShow: 4,
				}
			},{
				breakpoint: 620,
				settings: {
					slidesToShow: 3,
				}
			},{
				breakpoint: 460,
				settings: {
					slidesToShow: 2,
				}
			}
		]
	});

	//take read more href and apply to card overlay for each card
	$('.card, .featured').each(function(){
		var link = $(this).find('a.read-more');
		var overlay = $(this).find('a.overlay');
		var url = link.attr('href');
		overlay.attr('href',url);
	});

	//take h2 href and apply overlay for each ext resource
	$('.ext-resource').each(function(){
		var link = $(this).find('h2 > a');
		var overlay = $(this).find('a.overlay');
		var url = link.attr('href');
		overlay.attr('href',url);
	});

	$('.video-overlay-full-width').on('click', function(){
		
		var video_panel = $(this).find('.video-panel-hidden');
		var iframe = video_panel.find('iframe');
		iframe.attr("src", iframe.data("src"));
		video_panel.fadeIn('slow');
	});
	
	$('.event-video').on('click', function(){
		$(this).find('.event-video-placeholder').fadeOut('slow');
	});

	$("#sort-by").change(function(){
		//$(this).parentsUntil("form").submit();
		this.form.submit();
	});

	//Cookies
	if( getCookie('cookie-notice') === "" ){
		setCookie('cookie-notice', 'shown', 14);
		$('.cookie-notice').show();
	}
	$('#cookie-close').click(function(e){
		e.preventDefault();
		$('.cookie-notice').fadeOut();
	});
	
	if($(".banner-video").length > 0){ //Check if banner-video exists
		var video = $('<video autoplay id="banner-video" class="video-js" src="'+videoFileUrl+'"></video>');
		//Check if we will even both bother to try to play video
		//If possible in here we would check if the user is on a Mobile Network connection
		if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
			//Don't bother
			playSlideshowOrVideo("slideshow");
		}else{
			//Now that all other page assets are downloaded add the Video Tag
			$('.banner-video').append(video);
		
			var timer = setTimeout(function(){
				playSlideshowOrVideo("slideshow");
				bannerVideoPlayer.off("canplaythrough");
				$('.banner-video').remove(video);
			}, 2000);
			
			var bannerVideoPlayer = videojs(
				"banner-video", 
				{
					"preload": 'auto',
					"loop": true,
					"BigPlayButton": false,
					"ControlBar": false
				}
			);
			
			//When the video is ready to play
			bannerVideoPlayer.on("canplaythrough", function(){
				clearTimeout(timer);
				playSlideshowOrVideo("video");
				bannerVideoPlayer.off("canplaythrough");
			});
		}
	}else{
		bannerSliderInit(); //Init banner slider if no video present
	}

	//banner slider
	$('.article-slider').slick({
		dots: false,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		centerMode: true,
		variableWidth: true,
		nextArrow: '<button type="button" class="slick-next" aria-label="Previous slide"><span aria-hidden="true">&rsaquo;</span></button>',
		prevArrow: '<button type="button" class="slick-prev" aria-label="Next slide"><span aria-hidden="true">&lsaquo;</span></button>'
	});

});

$(window).load(function() {

	//packery - needs to load once after all page styles
	$('.variable-cards-wrapper').isotope({
		itemSelector: '.card',
		layoutMode: 'packery',
		packery : {
			gutter: 0
		}, 
		percentPosition: true
	});
	
	$('.events-listing').isotope({
		layoutMode: 'packery',
		packery : {
			gutter: 0
		},
		itemSelector: '.card',
		percentPosition: true
	});
	
	$(".tweet .time").each(function(){
		var createdAt = $(this).data('time');
		var timeSince = moment(createdAt, 'ddd MMM DD HH:mm:ss Z YYYY', 'en');
		$(this).append(timeSince.fromNow());
	});
	
	$(".tweet .summary").linkify({
		target: "_blank"
	});
	
});

function playSlideshowOrVideo(decision){
	if(decision == "slideshow"){
		$('.banner-slider').show();
		bannerSliderInit();
		$('#banner-poster').fadeOut('slow');
	}
	else if(decision == "video"){
		$('#banner-poster').fadeOut('slow');
		$('.banner-slider').hide();  
	}
}

function getCategory(){ //determine what category a card belongs to by looking at the URL it points to 
	$( ".card" ).each(function( index ) {
		var url = $(this).find('a.read-more').attr('href');
		var pathArray = url.split( '/' );
		var category = pathArray[3];
		
		if(category == 'working'){ // ads a class to cards based on their category in order to apply a corresponding border colour.
			$(this).addClass('working');
		} else if (category == 'living'){
			$(this).addClass('living');
		} else if (category == 'learning'){
			$(this).addClass('learning');
		}else if (category == 'about'){
			$(this).addClass('living');//about cards to be same colour as living cards per client request
		}
	});
}

function setCookie(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + (exdays*24*60*60*1000));
	var expires = "expires="+ d.toUTCString();
	document.cookie = cname + "=" + cvalue + "; " + expires;
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length,c.length);
        }
    }
    return "";
}
